import { App } from 'vue';
import Vue3Lottie from 'vue3-lottie';

export default function (app: App): void {
  app.use(Vue3Lottie);
}
